import { Component, inject, signal } from "@angular/core";
import { ConfirmationService, PrimeTemplate } from 'primeng/api';
import { CategoryService } from 'src/app/services/categories.service';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { AbstractListController } from 'src/app/common/abstract-list.component';
import { Tags } from 'src/app/models/tags';
import { TagsService } from 'src/app/services/tags.service';
import { PARAM_TAGS_PATH, PARAM_TYPE_PATH } from 'src/app/constants/constants';
import { TypeService } from 'src/app/services/type.service';
import { Type } from 'src/app/models/type';
import { Bind } from 'primeng/bind';
import { ButtonDirective } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { InputText } from 'primeng/inputtext';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { TranslatePipe } from '@ngx-translate/core';

import { DynamicFiltersComponent } from "../../../components/dynamic-filters/dynamic-filters.component";
import { TPipe } from "../../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: 'app-manage-type',
    templateUrl: './manage-type.component.html',
    imports: [TPipe, DynamicFiltersComponent, Bind, ButtonDirective, RouterLink, TableModule, PrimeTemplate, InputText, ConfirmDialog, TranslatePipe]
})
export class ManageTypeComponent extends AbstractListController<Type, any> {
  protected typeService: TypeService;
  protected confirmationService: ConfirmationService;

  title = 'Tags';
  readonly cols = signal<any[]>(undefined);
  readonly columnOptions = signal<any[]>(undefined);
  readonly selectedColumns = signal<any[]>(undefined);

  constructor() {
    const typeService = inject(TypeService);
    const confirmationService = inject(ConfirmationService);
    const router = inject(Router);
    const route = inject(ActivatedRoute);

    super(typeService, confirmationService, router, route, PARAM_TYPE_PATH);
    this.typeService = typeService;
    this.confirmationService = confirmationService;

    this.cols.set([
      { field: 'is_active', header: 'Attivo', index: 1 },
      { field: 'name', header: 'Nome', index: 1 },
      { field: 'description', header: 'Descrizione', index: 2 }
    ]);
    this.colsFilter.set([
      { field: "name", icon: "pi-tag", header: "Nome", type: "string" },
      { field: "description", icon: "pi-align-left", header: "Descrizione", type: "string" },
    ]);


    this.columnOptions.set([]);
    this.selectedColumns.set([]);
    for (let i = 0; i < this.cols().length; i++) {
      this.columnOptions.update((a) => { a.push({ label: this.cols()[i].header, value: this.cols()[i] }); return [...a]; });
    }
  }




}

